/**
 * @generated SignedSource<<c98be8f31135e401f3fdcdd5624b6fd9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PieceSettingsTempoItem_piece$data = {
  readonly id: string;
  readonly file: {
    readonly tempo: number;
  } | null;
  readonly " $fragmentType": "PieceSettingsTempoItem_piece";
};
export type PieceSettingsTempoItem_piece$key = {
  readonly " $data"?: PieceSettingsTempoItem_piece$data;
  readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsTempoItem_piece">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PieceSettingsTempoItem_piece",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MusicPieceFile",
      "kind": "LinkedField",
      "name": "file",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tempo",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MusicPiece",
  "abstractKey": null
};

(node as any).hash = "1fde5b9626b0d666ead1e842145c642d";

export default node;
